(() => {
  const init = () => {
    if (document.body.dataset.mchHomepageEffectsReady === 'true') return;
    document.body.dataset.mchHomepageEffectsReady = 'true';

    const main = document.querySelector('#MainContent');
    if (!main) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const hero = main.querySelector('.mch-immersive-hero');

    const revealTargets = Array.from(
      main.querySelectorAll('section h1, section h2, section h3, section h4, section p, section .mch-button, section .mch-text-link')
    ).filter(el => !el.closest('[hidden]') && !el.closest('.mch-immersive-hero'));

    revealTargets.forEach(el => el.classList.add('mch-reveal'));

    if ('IntersectionObserver' in window && !reducedMotion.matches) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

      revealTargets.forEach(el => observer.observe(el));
    } else {
      revealTargets.forEach(el => el.classList.add('is-visible'));
    }

    const parallaxTargets = Array.from(main.querySelectorAll(
      '.mch-immersive-hero__media img, .mch-immersive-hero__media video, .mch-editorial-visual img, .mch-clear-skin img, .mch-experience-tiles img'
    ));
    parallaxTargets.forEach(el => el.classList.add('mch-parallax-media'));

    let ticking = false;
    const updateParallax = () => {
      ticking = false;
      if (reducedMotion.matches) {
        parallaxTargets.forEach(el => { el.style.transform = ''; });
        return;
      }

      const viewportCenter = window.innerHeight / 2;
      parallaxTargets.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const elementCenter = rect.top + rect.height / 2;
        const offset = Math.max(-18, Math.min(18, (viewportCenter - elementCenter) * 0.035));
        el.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0) scale(1.02)';
      });
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    reducedMotion.addEventListener?.('change', onScroll);
    updateParallax();

    const backToTop = document.querySelector('.mch-back-to-top');
    if (backToTop) {
      const updateButton = () => {
        backToTop.classList.toggle('is-visible', window.scrollY > window.innerHeight);
      };
      window.addEventListener('scroll', updateButton, { passive: true });
      window.addEventListener('resize', updateButton, { passive: true });
      backToTop.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      });
      updateButton();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();